<div class="min-h-screen xl:flex">
  <div>
    <app-sidebar></app-sidebar>
    <app-backdrop></app-backdrop>
  </div>
  <div class="flex-1 overflow-x-hidden transition-all duration-300 ease-in-out" [ngClass]="{
        'xl:ml-[290px]': (isExpanded$ | async) || (isHovered$ | async),
        'xl:ml-[90px]': !(isExpanded$ | async) && !(isHovered$ | async),
        'ml-0': (isMobileOpen$ | async)
      }">
    <!-- app header start -->
    <app-header />
    <!-- app header end -->
    <div class="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6 overflow-x-hidden">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!-- Drawers "secundarios" (que pueden abrir drawers primarios desde su form). Van primero en el DOM -->
  <app-categoria-producto-form-drawer />
  <app-product-bundle-form-drawer />
  <app-discount-rule-form-drawer />
  <app-price-list-form-drawer />
  <app-producto-form-drawer />
  <app-meeting-form-drawer />
  <app-cancellation-reasons-form-drawer />
  <app-holidays-form-drawer />
  <app-meeting-types-form-drawer />
  <app-meeting-statuses-form-drawer />
  <app-availability-overrides-form-drawer />
  <app-email-templates-form-drawer />
  <app-routing-rules-form-drawer />
  <app-task-form-drawer />
  <app-task-types-form-drawer />
  <app-task-statuses-form-drawer />
  <app-task-priorities-form-drawer />
  <app-task-categories-form-drawer />
  <app-task-cancel-reasons-form-drawer />
  <app-template-category-form-drawer />
  <app-phone-number-form-drawer />
  <app-quote-approver-form-drawer />
  <app-email-channel-policy-form-drawer />
  <app-role-form-drawer />

  <!-- Drawers "primarios" (contactos/empresas/leads/deals): se abren desde otros drawers, deben quedar arriba en stack. Van al final del DOM -->
  <app-deal-form-drawer />
  <app-lead-form-drawer />
  <app-contacto-form-drawer />
  <app-empresa-form-drawer />
  <app-tickets-form-drawer />
  <app-tickets-priorities-form-drawer />
  <app-tickets-statuses-form-drawer />
  <app-tickets-categories-form-drawer />
  <app-tickets-root-causes-form-drawer />
  <app-tickets-canned-responses-form-drawer />
  <app-tickets-pipelines-form-drawer />
  <app-tickets-pipeline-stages-form-drawer />
  <app-tickets-teams-form-drawer />
  <app-tickets-team-members-form-drawer />
  <app-chat-teams-form-drawer />
  <app-chat-team-member-form-drawer />
  <app-tickets-sla-policies-form-drawer />
  <app-tickets-sla-targets-form-drawer />
  <app-tickets-custom-fields-form-drawer />
  <app-tickets-assignment-rules-form-drawer />
  <app-tickets-escalation-rules-form-drawer />

  @if (showCallDialer) {
    <app-call-dialer-widget />
  }

  <!-- Compose flotante de correo (global, tipo Gmail) -->
  <app-email-compose />

  <app-whatsapp-compose />

  <!-- Detalle de cotización (global, incidente #27): se abre desde la lista de cotizaciones vía
       QuoteDetailModalService. Va ANTES del wizard en el DOM para que "Editar" desde el detalle
       abra el wizard POR ENCIMA (mismo token z-modal → gana el orden del DOM). -->
  <app-quote-detail-modal
    [isOpen]="quoteDetailState.open"
    [quoteId]="quoteDetailState.quoteId ?? null"
    (close)="onQuoteDetailClosed()" />

  <!-- Wizard de cotización (global): se abre desde la lista de cotizaciones o desde el
       detalle/kanban/lista de negocios. Va después del router-outlet para quedar por encima
       (mismo token z-modal, gana el orden del DOM) del detalle de negocio que lo abre. -->
  @if (quoteModalState.open) {
    <app-quotes-form
      [modalMode]="true"
      [modalQuoteId]="quoteModalState.quoteId ?? null"
      [modalSendEmail]="quoteModalState.sendEmail ?? false"
      [modalDealId]="quoteModalState.dealId ?? null"
      (savedQuote)="onQuoteModalSaved()"
      (closed)="onQuoteModalClosed()" />
  }

  <app-segment-set-ops-modal />
  <app-confirm-dialog />
  <app-toast-container />
</div>